import React from 'react';
import Gdpr from './Gdpr';
import Layout from '../../../components/Layout';

function action() {
  return {
    title: 'Legal - GDPR policy',
    component: (
      <Layout>
        <Gdpr />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/routes/legal/gdpr/index.js